module.exports = __webpack_public_path__ + "img/298-d8e96a.png";